module.exports = __webpack_public_path__ + "static/media/check-mark.24209b50.svg";